import { routes } from "schemas/routes";

export const instagramOnboardingNavigate = (
  currentPathname: string,
  direction: "next" | "back",
) => {
  const pageOrders = [
    routes.preferencesInstagramOnboarding,
    routes.aboutInstagramOnboarding,
    routes.categoryInstagramOnboarding,
  ];
  const currentPageIndex = pageOrders.findIndex((page) =>
    currentPathname.endsWith(page),
  );

  if (currentPageIndex === -1) {
    return routes.preferencesInstagramOnboarding;
  }
  if (direction === "next") {
    if (currentPageIndex === pageOrders.length - 1) {
      return `/${routes.dashboard}`;
    }
    return pageOrders[currentPageIndex + 1];
  } else {
    if (currentPageIndex === 0) {
      return routes.preferencesInstagramOnboarding;
    }
    return pageOrders[currentPageIndex - 1];
  }
};
